import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--delete" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "退会", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-mypage__sec" }
const _hoisted_5 = { class: "p-mypage__field-container" }
const _hoisted_6 = { class: "p-fields" }
const _hoisted_7 = { class: "c-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "detail"
}, "退会理由", -1)
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "c-field__textarea" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "c-field has-submit has-mt" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "c-btn is-submit"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "退会する")
  ])
], -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("section", { class: "p-mypage__sec" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, [
    /*#__PURE__*/_createTextVNode("退会するにはSHUEISHA IDでご利用中のサービスの退会が必要です。"),
    /*#__PURE__*/_createElementVNode("br", { class: "u-br-pc" }),
    /*#__PURE__*/_createTextVNode("事前に各連携サービスの退会画⾯から退会を⾏ってください。")
  ])
], -1)
const _hoisted_14 = { class: "p-mypage__sec" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "p-messages" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt c-message__txt--primary" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "ご利⽤中のサービスがございます。事前に各連携サービスの退会を⾏ってください。")
    ])
  ])
], -1)
const _hoisted_16 = {
  key: 0,
  class: "p-messages"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "c-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "c-message__txt c-message__txt--primary" }, [
    /*#__PURE__*/_createElementVNode("i"),
    /*#__PURE__*/_createElementVNode("span", null, "ご利用中のサービス一覧の取得に失敗しました。ブラウザの更新をお試しください。")
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "p-mypage__field-container" }
const _hoisted_20 = { class: "p-fields p-fields--delete" }
const _hoisted_21 = { class: "c-field__label" }
const _hoisted_22 = {
  key: 0,
  class: "c-field__body"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "サイトの退会画面へ", -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "サイトの退会画面へ", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "c-field"
}
const _hoisted_28 = { class: "c-field__label" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "c-field__note" }, "スマホアプリで退会操作を行ってください", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "c-field__body"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "サイトの退会画面へ", -1)
const _hoisted_34 = ["href"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "サイトの退会画面へ", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  class: "c-field has-submit has-mt",
  style: {"justify-content":"center"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_ctx.isDispFormRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.withdrawal && _ctx.withdrawal(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("fieldset", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("textarea", {
                          id: "detail",
                          name: "detail",
                          class: "textarea",
                          cols: "",
                          rows: "5",
                          spellcheck: "false",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.leaveNote.leaveNote1) = $event)),
                          placeholder: "こちらに詳細を入力してください。"
                        }, null, 512), [
                          [_vModelText, _ctx.leaveNote.leaveNote1]
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_11
                ])
              ])
            ], 32)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("section", _hoisted_14, [
            _hoisted_15,
            (_ctx.registeredSiteList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("fieldset", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredSiteList, (registeredSite) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: registeredSite.link_id!
                  }, [
                    (!!registeredSite.children)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(registeredSite.children, (subSite) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subSite.linkage_sub_id!,
                            class: "c-field"
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(subSite.name) + "(" + _toDisplayString(subSite.name_jp) + ")", 1),
                            (subSite.kind !== 'apl')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (subSite.is_close === true)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: { name: 'QuitService', query: { siteLinkageId: subSite.link_id } },
                                        class: "c-btn c-btn--outline"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_23
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true),
                                  (subSite.is_close === false)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        href: subSite.withdrawal_url as string,
                                        class: "c-btn c-btn--outline",
                                        target: "_blank"
                                      }, _hoisted_26, 8, _hoisted_24))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(registeredSite.name) + "(" + _toDisplayString(registeredSite.name_jp) + ")", 1),
                          (registeredSite.kind === 'apl')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (registeredSite.is_close === true)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: { name: 'QuitService', query: { siteLinkageId: registeredSite.link_id } },
                                      class: "c-btn c-btn--outline"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_33
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                (registeredSite.is_close === false)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: registeredSite.withdrawal_url as string,
                                      class: "c-btn c-btn--outline",
                                      target: "_blank"
                                    }, _hoisted_36, 8, _hoisted_34))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "c-btn c-btn--outline",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
                  }, _hoisted_39)
                ])
              ])
            ])
          ])
        ]))
  ], 64))
}